export default [
  {
    content: "물질안전보건자료(MSDS)를 비치하고, 경고표지를 부착하였는가?",
    isChecked: "",
  },
  {
    content: "탱크를 쉽게 구분하도록 설비번호를 게시 또는 표시하였는가?",
    isChecked: "",
  },
  {
    content: "탱크 외면에 현저한 부식, 균열 및 파손이 발생하지 않았는가?",
    isChecked: "",
  },
  {
    content: "보온재의 파손 또는 탈락이 없고 페인트 도색도 양호한가?",
    isChecked: "",
  },
  {
    content: "과압 및 부압을 해소하기 위해 통기관 또는 통기밸브를 설치하고, 입구 측 배관은 밸브로 차단되지 않았는가?",
    isChecked: "",
  },
  {
    content: "인화성 액체를 저장하는 탱크의 통기관에 화염방지기(또는 인화방지망)를 설치하였는가?",
    isChecked: "",
  },
  {
    content: "대기환경처리설비를 통해 탱크에서 발생하는 휘발성 유기화합물(VOC)등을 처리하는가?",
    isChecked: "",
  },
  {
    content: "탱크 지붕에서 작업할 때 유증기 배출 부위(통기관 등) 주변으로 용접불티, 그라인더 불꽃 등과 같은 점화원이 유입되지 않도록 사전에 필요한 조치를 하는가?",
    isChecked: "",
  },
  {
    content: "온도계, 액위게, 압력계 등 계측장치가 탱크에 설치되어 있고 정상 기능을 유지하고 있는가?",
    isChecked: "",
  },
  {
    content: "입하작업 중 탱크의 흘러넘침(Overflow)을 방지하기 위해 고액위경보장치, 액위조절장치(Level switch)와 같은 자동경보장치 또는 자동제어 장치를 설치하고 정상 기능을 유지하고 있는가?",
    isChecked: "",
  },
  {
    content: "위험물질 저장탱크의 안전거리 또는 보유공지를 확보하였는가?",
    isChecked: "",
  },
  {
    content: "비상시 소방차 등 긴급차량이 들어오는 진입경로에 장애물이 있거나 적재품이 방치되어 있지 않은가?",
    isChecked: "",
  },
  {
    content: "탱크 저장용량 이상으로 방유제가 충분히 크게 설치되었는가?",
    isChecked: "",
  },
  {
    content: "방유제 배관 관통부에 실링 처리로 막음조치가 되어 있고 내·외면의 구멍이나 현저한 균열 및 파손은 없는가?",
    isChecked: "",
  },
  {
    content: "탱크 측면 계단에 안전난간대와 수직사다리 방호울이 있고, 지붕에 안전난간대 발끝막이판이 설치되어 있는가?",
    isChecked: "",
  },
  {
    content: "정전기 방지를 위해 접지 또는 본딩을 실시하고, 접속 부위에 녹, 페인트 등 이물질이 없도록 관리하는가?",
    isChecked: "",
  },
  {
    content: "저장탱크가 실외에 설치된 경우, 방유제 용랑을 비롯한 설치 상태가 관련 법규에맞는가?",
    isChecked: "",
  },
  {
    content: "방유제 내에 가스누출감지기 또는 누액감지기를 설치하고, 집수조에 누출감지 센서를 설치하였는가?",
    isChecked: "",
  },
  {
    content: "제작 결함 및 부식으로 가압식 소화기의 기계적 강도가 저하되어 소화기 작동 시 폭발로 인한 재해 사례를 알고 있으며, 가압식 소화기를 모두 축압식 소화기로 교체하였는가?",
    isChecked: "",
  },
  {
    content: "여름철 옥외에서 직사광선을 계속 받으면 소화기가 터질 수 있음을 알고 있으며, 소화기를 과충전하지 않고 전용 보관함에 비치하거나 항상 전용커버를 씌워 보관하는가?",
    isChecked: "",
  },
];
